// extracted by css-extract-rspack-plugin
export default {"CreateIssueContainer":"CreateIssue-module__CreateIssueContainer__ueahp","LoadingContainer":"CreateIssue-module__LoadingContainer__S2Oxl"};